import React from 'react';
import { useSelector } from 'react-redux';
import './Stepper.css';

export function Stepper({ steps }) {
  const current = useSelector(state => state.ideaSubmission.currentStep);

  const defaultLabels = ['Select Type', 'Add Content', 'Review & Submit'];
  const raw = Array.isArray(steps) && steps.length ? steps : defaultLabels;

  const items = raw.map(step =>
    typeof step === 'string'
      ? { key: step.toLowerCase().replace(/\s+/g, '_'), heading: step }
      : step
  );

  const count = items.length;

  return (
    <div className="stepper-container">
      {/* Connectors between dots */}
      {items.slice(0, count - 1).map((_, idx) => {
        const leftPct = (idx / (count - 1)) * 100;
        const nextLeftPct = ((idx + 1) / (count - 1)) * 100;
        const isCompleted = idx < current;
        return (
          <div
            key={`connector-${idx}`}
            className={`stepper-connector ${isCompleted ? 'completed' : ''}`}
            style={{
              left: `calc(${leftPct}% + var(--dot-radius) + var(--connector-gap))`,
              width: `calc(${nextLeftPct}% - ${leftPct}% - 2*var(--dot-radius) - 2*var(--connector-gap))`
            }}
          />
        );
      })}

      {/* Markers */}
      {items.map(({ key, heading, icon }, idx) => {
        const leftPct = count > 1 ? (idx / (count - 1)) * 100 : 0;
        const isActive = idx === current;
        const isCompleted = idx < current;

        return (
          <div
            key={key}
            className="stepper-marker"
            style={{ left: `${leftPct}%` }}
          >
            <div
              className={`
                stepper-dot
                ${isCompleted ? 'completed' : ''}
                ${isActive    ? 'active'    : ''}
              `}
            >
              {isCompleted ? (
                <i className="bi bi-check-lg" aria-hidden="true" />
              ) : icon ? (
                <i className={`bi ${icon}`} aria-hidden="true" />
              ) : (
                idx + 1
              )}
            </div>
            <div className="stepper-label">{heading}</div>
          </div>
        );
      })}
    </div>
  );
}